<header-bar title="Youtine"></header-bar>
<div class="page-content">

    <div class="card" style="background-color: transparent!important;margin-bottom: 0; margin-top: 0;">
        <div class="content" style="margin-bottom: 6px; margin-top: 0">
            <% if ( null === activePlan ) {  %>
                <h1 class="pb-4r"><img src="assets/images/youtine-logo-white.svg" class="mx-auto" width="240px"></h1>
                <h1 class="text-white text-center">
                    Herzlich Willkommen in deiner Routine App
                </h1>
                <div class="card card-style mt-3" style="background-color: white!important;">
                    <div class="content text-center">
                        <p class="font-weight-bolder ">
                            Wir starten mit deiner individuellen Routine um 0:00 Uhr, bis dahin hast du noch Zeit deine Routine in den <a href="/routine/settings" style="color: #727272!important;">Einstellungen</a> <i class="fas fa-bars"></i> anzupassen.
                        </p>
                        <p class="font-weight-bolder">
                            Den Stand deines zurückgewonnenen Motivationsbeitrages, findest du unter Erfolge <i class="fa-solid fa-trophy-star"></i>.
                        </p>
                        <p class="font-weight-bolder">
                            Das Versprechen, dass du dir heute geben musst ist:
                        </p>
                        <h2 style="margin-bottom: 1rem; color: #727272">
                            Sei immer ehrlich zu dir !
                        </h2>
                        <p class="font-weight-bolder">
                            Nur so kannst du mit unserer Hilfe deine Ziele langfristig erreichen.
                        </p>
                        <h2 style="margin-bottom: 1rem; color: #727272">
                            Wir wünschen dir viel Spaß und Erfolg.
                        </h2>
                    </div>
                </div>

            <% } else if ( activePlan.routines.length > 0 ) { %>

                <% let routines = activePlan.getDailyMorningRoutines() %>
                <% if ( routines.length > 0 ) { %>
                    <h2 class="text-white text-left text-uppercase">
                        Morgenroutine
                    </h2>
                    <% if ( routines && routines.length > 0 ) { %>
                        <% for ( let ri = 0; ri < routines.length; ri++ ) { %>
                            <routine-check-item name="<%= routines[ ri ].name %>"
                                                uuid="<%= routines[ ri ].uuid %>"
                                                icon="<%= routines[ ri ].icon %>"></routine-check-item>
                        <% }    %>
                    <% } %>
                <% }    %>

                <% routines = activePlan.getDailyMiddayRoutines(); %>
                <% if ( routines && routines.length > 0 ) { %>
                    <h2 class="text-white text-left text-uppercase mt-4">
                        Mittagsroutine
                    </h2>
                    <% for ( let ri = 0; ri < routines.length; ri++ ) { %>

                        <routine-check-item name="<%= routines[ ri ].name %>"
                                            uuid="<%= routines[ ri ].uuid %>"
                                            icon="<%= routines[ ri ].icon %>"></routine-check-item>

                    <% }    %>
                <% }    %>

                <% routines = activePlan.getDailyEveningRoutines() %>
                <% if ( routines && routines.length > 0 ) { %>
                    <h2 class="text-white text-left text-uppercase mt-4">
                        Abendroutine
                    </h2>
                    <% for ( let ri = 0; ri < routines.length; ri++ ) { %>

                        <routine-check-item name="<%= routines[ ri ].name %>"
                                            uuid="<%= routines[ ri ].uuid %>"
                                            icon="<%= routines[ ri ].icon %>"></routine-check-item>

                    <% }    %>

                <% } %>

                <% routines = activePlan.getDailyGoalRoutines() %>
                <% if ( routines && routines.length > 0 ) { %>

                    <h2 class="text-white text-left text-uppercase mt-4">
                        Tagesziele
                    </h2>
                    <% for ( let ri = 0; ri < routines.length; ri++ ) { %>

                        <routine-check-item name="<%= routines[ ri ].name %>"
                                            uuid="<%= routines[ ri ].uuid %>"
                                            icon="<%= routines[ ri ].icon %>"></routine-check-item>
                    <% }    %>
                <% }  %>

                <% routines = activePlan.getWeeklySportGoalRoutines() %>
                <% routines = routines.concat( activePlan.getWeeklyConsumeGoalRoutines() ) %>
                <% routines = routines.concat( activePlan.getWeeklySpiritGoalRoutines() ) %>
                <% routines = routines.concat( activePlan.getWeeklyGoalRoutines() ) %>
                <% if ( routines && routines.length > 0 ) { %>

                    <h2 class="text-white text-left text-uppercase mt-4">
                        Wochenziele
                    </h2>
                    <p class="font-weight-bolder text-white text-left">
                        Deine Woche beginnt jeweils am <%= activePlan.momentBeginnUtc.format( 'dddd' ) %> um 0:00&nbsp;Uhr und endet in der darauffolgenden Woche am <%= activePlan.momentEndUtc.format( 'dddd' ) %> um 23:59&nbsp;Uhr.
                    </p>

                    <% for ( let ri = 0; ri < routines.length; ri++ ) { %>

                        <routine-check-item name="<%= routines[ ri ].name %>"
                                            goal="weekly"
                                            uuid="<%= routines[ ri ].uuid %>"
                                            weekly-count="<%= routines[ ri ].weeklyCount %>"
                                            weekly-frequence="<%= routines[ ri ].weeklyFrequence %>"
                                            icon="<%= routines[ ri ].icon %>"></routine-check-item>
                    <% }    %>
                <% }    %>

            <% } else { %>

                <p class="text-center" style="margin-top: 32px">
                    <img src="/assets/images/pokal.png"
                         style="max-width: 30vw"
                         class="img-fluid" />
                </p>
                <div class="card card-style mt-3" style="background-color: white!important;">
                    <div class="content text-center">
                        <h1>Herzlichen Glückwunsch!</h1>
                        <p class="mb-2 font-weight-bolder">
                            Du hast deine heutige Routine erfolgreich abgeschlossen - großartig gemacht!
                        </p>
                        <p class="font-weight-bolder">
                            Du hast damit etwas Beeindruckendes erreicht. Nutze die restliche Zeit des Tages, um über deine gewohnte Routine hinauszuwachsen und vielleicht sogar etwas Unglaubliches zu schaffen.
                        </p>
                    </div>
                </div>

            <% }    %>
        </div>
    </div>


</div>
<main-menu active-item="index"></main-menu>
<!-- PWA Install Logic -->
<pwa-install
        disable-screenshots="true"
        disable-screenshots-apple="true"
        disable-screenshots-chrome="true"

        manifest-url="/manifest.json">
</pwa-install>
